export default "__VITE_ASSET__D0QL1JyX__"